// automationActionEditorUtils.js

export const EMAIL_RECIPIENT_SOURCE_OPTIONS = [
  { value: 'explicit_members', label: 'Specific members' },
  { value: 'trigger_people_field', label: 'People field on this record' },
  { value: 'related_node_people_field', label: 'People field on related records' },
];

const ALLOWED_ACTION_TYPES = new Set(['set_field', 'send_email']);

export const getActionType = (action) => {
  const rawType = String(action?.type || '').trim().toLowerCase();
  return ALLOWED_ACTION_TYPES.has(rawType) ? rawType : 'set_field';
};

export const normalizeRecipientSource = (action) => {
  const rawType = String(action?.recipientSource?.type || '').trim().toLowerCase();
  const type = EMAIL_RECIPIENT_SOURCE_OPTIONS.some((option) => option.value === rawType)
    ? rawType
    : 'explicit_members';

  const legacyRecipientKeys = Array.isArray(action?.target?.recipientUserKeys)
    ? action.target.recipientUserKeys
    : [];

  return {
    type,
    explicitMemberUserKeys: Array.from(new Set(
      (Array.isArray(action?.recipientSource?.explicitMemberUserKeys)
        ? action.recipientSource.explicitMemberUserKeys
        : legacyRecipientKeys
      )
        .map((value) => String(value || '').trim())
        .filter(Boolean),
    )),
    triggerPeopleFieldKey: String(action?.recipientSource?.triggerPeopleFieldKey || '').trim(),
    relatedNodeTypeKey: String(action?.recipientSource?.relatedNodeTypeKey || '').trim(),
    relatedPeopleFieldKey: String(action?.recipientSource?.relatedPeopleFieldKey || '').trim(),
  };
};

export const normalizeMessageConfig = (action) => ({
  text: String(action?.message?.text || ''),
  includedFieldKeys: Array.isArray(action?.message?.includedFieldKeys)
    ? action.message.includedFieldKeys
    : [],
});

export const normalizeActionValueType = (actionValueType, allowedModes) => {
  const rawActionValueType = ['now', 'null', 'add', 'remove'].includes(actionValueType)
    ? actionValueType
    : 'literal';

  return allowedModes.includes(rawActionValueType)
    ? rawActionValueType
    : allowedModes[0];
};

export const buildRecipientModalPeopleValue = (action) => {
  const recipientSource = normalizeRecipientSource(action);
  return recipientSource.explicitMemberUserKeys.map((userKey) => {
    const key = String(userKey || '').trim();
    return {
      key,
      userKey: key,
      title: key,
    };
  });
};

/**
 * Resolves display profiles for explicit-member recipients in the automation editor.
 * @param {string[]} userKeys
 * @param {Array<{ userKey?: string, id?: string, key?: string, title?: string, name?: string, coverUrl?: string, user?: object }>} baseMembers
 * @returns {Array<{ userKey: string, name: string, coverUrl: string|null }>}
 */
export const resolveExplicitRecipientProfiles = (userKeys = [], baseMembers = []) => {
  const keys = Array.from(new Set(
    (Array.isArray(userKeys) ? userKeys : [])
      .map((value) => String(value || '').trim())
      .filter(Boolean),
  ));

  const members = Array.isArray(baseMembers) ? baseMembers : [];

  return keys.map((userKey) => {
    const match = members.find((member) => {
      const memberKey = String(member?.userKey || member?.key || member?.id || '').trim();
      return memberKey === userKey;
    });

    const name = String(
      match?.title
      || match?.name
      || match?.user?.name
      || '',
    ).trim() || userKey;

    const coverUrl = String(
      match?.coverUrl
      || match?.user?.coverUrl
      || match?.data_profile?.coverUrl
      || '',
    ).trim() || null;

    return {
      userKey,
      name,
      coverUrl,
    };
  });
};
